<!-- 车场上线情况 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList": ["2KKN885S"],
                "areaType": 0,
                "number": 1
            },
            responseCode: {
                    "data": {
                        "recordList": [
                            {
                                "areaId": "440605011",
                                "areaName": "广东省",
                                "fullPath": "440000000.440600000.440605000.440605011",
                                "parkCode": "2KKN885S",
                                "parkName": "昌俊停车场",
                                "parkPinYing": "CJTCC",
                                "parkSpace": 380,
                                "publishDate": 1483200000000,
                                "publishDateStr": "2017-01-01 00:00:00",
                                "remainPostionNum": 50
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车场上线情况",
                t_url: this.commonUrls.test+"parkOnlineData",
                p_url: this.commonUrls.prod+"parkOnlineData",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编码数组' },
                        { info1: 'areaType', info2: '是', info3: 'Integer', info4: '区域类型,0省级 1市级 2区级 3县级' },
                        { info1: 'number', info2: '是', info3: 'Long', info4: '数据条数' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'areaId', info2: '是', info3: 'String', info4: '区域id' },
                        { info1: 'areaName', info2: '是', info3: 'String', info4: '区域名称' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkSpace', info2: '是', info3: 'Integer', info4: '车位数' },
                        { info1: 'remainPostionNum', info2: '是', info3: 'Integer', info4: '剩余车位数' },
                        { info1: 'publishDate', info2: '是', info3: 'long', info4: '上架时间时间戳' },
                        { info1: 'publishDateStr', info2: '是', info3: 'String', info4: '上架时间，yyyyMMddHHmmss' },
                        { info1: 'fullPath', info2: '是', info3: 'String', info4: '区域完整编号' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/parkOnlineData.vue